/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FleetChangeInput } from '../models/FleetChangeInput';
import type { FleetCosts } from '../models/FleetCosts';
import type { FleetEntries } from '../models/FleetEntries';
import type { FleetStats } from '../models/FleetStats';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FleetsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Fleet Entries
   * @returns FleetEntries Entries
   * @throws ApiError
   */
  public fleetEntries({
    id,
    search,
    coverStatus,
    include,
    limit = 10,
    after,
  }: {
    id: string,
    search?: string,
    coverStatus?: string,
    include?: string,
    limit?: number,
    after?: string,
  }): CancelablePromise<FleetEntries> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/fleet-entries',
      path: {
        'id': id,
      },
      query: {
        'search': search,
        'coverStatus': coverStatus,
        'include': include,
        'limit': limit,
        'after': after,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * Fleet Stats
   * @returns FleetStats The Fleet Stats
   * @throws ApiError
   */
  public fleetStats({
    id,
  }: {
    id: string,
  }): CancelablePromise<FleetStats> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/fleet-stats',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * Change Fleet
   * @returns any Policy
   * @throws ApiError
   */
  public changeFleet({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Changes
     */
    requestBody: {
      requestedAccessLevel?: 'standard' | 'elevated';
      changes: Array<FleetChangeInput>;
    },
  }): CancelablePromise<{
    id: string;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/change-fleet',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * Fleet Costs
   * @returns FleetCosts OK
   * @throws ApiError
   */
  public fleetCosts({
    id,
    from,
    to,
    limit,
    after,
    include,
    groupId,
  }: {
    /**
     * The id of the Policy
     */
    id: string,
    /**
     * The time to load costs from
     */
    from?: string,
    /**
     * The time to load costs to
     */
    to?: string,
    /**
     * The number of costs to return
     */
    limit?: number,
    /**
     * The cursor from the previous response
     */
    after?: string,
    /**
     * A comma separated list of vehicle properties
     */
    include?: string,
    /**
     * Optional groupId to filter costs for a specific fleet change/adjustment
     */
    groupId?: string,
  }): CancelablePromise<FleetCosts> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/fleet-costs',
      path: {
        'id': id,
      },
      query: {
        'from': from,
        'to': to,
        'limit': limit,
        'after': after,
        'include': include,
        'groupId': groupId,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
      },
    });
  }

}
